import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M13.9993 0.720703C6.66602 0.720703 0.666016 6.70737 0.666016 14.0807C0.666016 20.7474 5.54601 26.2807 11.9193 27.2807V17.9474H8.53268V14.0807H11.9193V11.134C11.9193 7.78737 13.906 5.94737 16.9594 5.94737C18.4127 5.94737 19.9327 6.2007 19.9327 6.2007V9.49404H18.2527C16.5993 9.49404 16.0793 10.5207 16.0793 11.574V14.0807H19.786L19.186 17.9474H16.0793V27.2807C19.2213 26.7845 22.0823 25.1814 24.1459 22.7608C26.2095 20.3402 27.3398 17.2616 27.3327 14.0807C27.3327 6.70737 21.3327 0.720703 13.9993 0.720703Z",
      fill: "#152443"
    }, null, -1)
  ]))]))
}
export default { render: render }